var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.loadingPane,
          expression: "loadingPane",
        },
      ],
      staticClass: "search-loading",
    },
    [_vm.showSpinner ? [_vm._m(0)] : _vm._e()],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "search-loading__spinner" }, [
      _c("div", { staticClass: "lds-rolling" }, [_c("div")]),
      _c("div", { staticClass: "loading__label" }, [
        _vm._v("We will be back with your results right away..."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }